import { Project } from "./project.model";

export class AreaOfWork {
  constructor(
    public name: string,
    public projects: Project[] = [],
    public fiveYearCapitalNeeds: number = 0,
    public twentyYearCapitalNeeds: number = 0,
  ) {}
}
